<div class="wsu-main">
  <app-impersonation-confirm-modal
    testId="impersonate-staff-dialog"
    *ngIf="confirmVisible && confirmMember"
    titleId="wsu-staff-confirm-title"
    title="Impersonate staff"
    [busy]="!!busyKey"
    (cancel)="closeConfirm()"
    (confirm)="onConfirmImpersonate()"
  >
    Start an impersonation session for
    <strong>“{{ confirmMember.name }}”</strong>
    <span *ngIf="confirmMember.email"> ({{ confirmMember.email }})</span>
    at <strong>{{ companyName() }}</strong
    >? A new tab will open with the staff session.
  </app-impersonation-confirm-modal>

  <div class="wsu-filters">
    <div class="wsu-filter-field wsu-filter-field--search">
      <label class="wsu-label" for="staff-search">Search employees</label>
      <input
        id="staff-search"
        class="form-control"
        type="search"
        placeholder="Search by name, email…"
        [ngModel]="searchTerm"
        (ngModelChange)="onSearchInput($event)"
      />
    </div>
    <div class="wsu-filter-field">
      <label class="wsu-label" for="staff-status">Status</label>
      <mat-select
        id="staff-status"
        panelClass="wsu-status-select-panel"
        [(ngModel)]="empStatusFilter"
        (ngModelChange)="onStatusFilterChange()"
        [style]="{ width: '100%' }"
      >
        <mat-option *ngFor="let empStatus of empStatusOptions" [value]="empStatus.value">{{
          empStatus.label
        }}</mat-option>
      </mat-select>
    </div>
  </div>

  <div class="wsu-state" *ngIf="loadingStaff">Loading staff…</div>
  <div class="wsu-state wsu-state--error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <app-impersonation-empty-state
    testId="impersonate-staff-empty-state"
    *ngIf="!loadingStaff && !errorMessage && staff.length === 0"
    icon="staff"
    title="No Employees Found"
    text="This shop doesn’t have any employees matching your current filters. Try clearing search or switching status."
    [hint]="'No staff available for ' + (companyName() || 'this shop')"
  ></app-impersonation-empty-state>

  <div class="wsu-table-wrap" *ngIf="!loadingStaff && staff.length > 0">
    <table class="wsu-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Role</th>
          <th>Location</th>
          <th>Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let member of staff">
          <td class="wsu-table__name">{{ member.name }}</td>
          <td>{{ member.email }}</td>
          <td>
            <span class="wsu-pill">{{ member.designation || member.role }}</span>
          </td>
          <td>{{ member.location_name || member.location_id || '—' }}</td>
          <td>
            <span
              class="wsu-pill"
              [class.wsu-pill--off]="member.is_active === false || member.emp_status === false"
            >
              {{
                member.is_active === false || member.emp_status === false ? 'Inactive' : 'Active'
              }}
            </span>
          </td>
          <td class="wsu-table__action">
            <button
              type="button"
              class="btn btn-primary btn-medium"
              [disabled]="busyKey === member.id || confirmVisible"
              (click)="impersonate(member)"
            >
              {{ busyKey === member.id ? 'Opening…' : 'Impersonate' }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <app-pagination-bar
    *ngIf="totalItems > 0"
    [paginationData]="paginationData"
    [itemsPerPageOptions]="[10, 20, 50]"
    (pageChange)="onPageChange($event)"
    (itemsPerPageChange)="onItemsPerPageChange($event)"
  ></app-pagination-bar>
</div>
